import { __awaiter, __decorate } from "tslib";
import { Component } from '@angular/core';
import { SharedHttp } from "../../../../services/http-client.service";
import { AuthService } from "../../../../services/auth.service";
import { Router } from "@angular/router";
import { forkJoin } from "rxjs";
import { WebClientService } from "../../../../services/webclient-settings.service";
let StakingComponent = class StakingComponent {
    constructor(auth, router, httpClient, webSettingsService) {
        this.auth = auth;
        this.router = router;
        this.httpClient = httpClient;
        this.webSettingsService = webSettingsService;
        this.stakes = [];
        this.stakeCurrencies = [];
        this.wallets = [];
        this.prices = [];
        this.dataLoaded = false;
        this.goToStakingTab = false;
        this.auth.fetchUser().then(result => {
            this.user = JSON.parse(localStorage.getItem('user'));
            if (!this.user || !this.user.eligible_for_wallet) {
                this.router.navigateByUrl('');
            }
        });
        this.webSettingsService.getSettings().subscribe((data) => {
            if (Object.keys(data).length > 0) {
                if (!this.webSettingsService.applySettings('WALLET.MENU.STAKING.VISIBLE')) {
                    this.router.navigateByUrl('');
                }
            }
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            const [stakes, currencies, wallets, prices] = yield forkJoin([
                this.httpClient.get('staking/stakes'),
                this.httpClient.get('wallet/getallcurrencies'),
                this.httpClient.get('wallet/getwallets'),
                this.httpClient.get('market/pricesforwallet'),
            ]).toPromise();
            this.stakes = stakes.stakes;
            this.stakeCurrencies = currencies.currencies.filter(currency => currency.stakable === true);
            this.wallets = wallets.wallets;
            this.prices = prices;
            this.dataLoaded = true;
        });
    }
    setGoToStakingTab($event) {
        return __awaiter(this, void 0, void 0, function* () {
            const [stakes, prices] = yield forkJoin([
                this.httpClient.get('staking/stakes'),
                this.httpClient.get('market/pricesforwallet'),
            ]).toPromise();
            this.stakes = stakes.stakes;
            this.prices = prices;
            this.goToStakingTab = $event;
        });
    }
};
StakingComponent.ctorParameters = () => [
    { type: AuthService },
    { type: Router },
    { type: SharedHttp },
    { type: WebClientService }
];
StakingComponent = __decorate([
    Component({
        selector: 'ecd-staking',
        template: __importDefault(require("./staking.component.html")).default,
    })
], StakingComponent);
export { StakingComponent };
